import { TweaksPanel, TweakSection, TweakRadio, TweakSelect } from './TweaksPanel.tsx';
import { PHASE_SEQUENCE } from '../lib/activePhase.ts';
import type { PhasePreviewTweaks } from '../lib/previewPhaseOverride.ts';
import type { PhaseId } from '../lib/types.ts';

const PHASE_LABELS: Record<PhaseId, string> = {
  teaser: 'Teaser',
  weekly: 'Ugentlig',
  lineup: 'Lineup',
  days: 'Spilledage',
  schedule: 'Spilleplan',
  during: 'Under festivalen',
  after: 'Efter festivalen',
};

export interface PhasePreviewSwitcherProps {
  readonly tweaks: PhasePreviewTweaks;
  readonly setTweak: (key: string | Partial<PhasePreviewTweaks>, val?: unknown) => void;
}

/**
 * Floating preview-only control (CMS-054) letting an editor pick any of the 7
 * festival phases to see how a CMS page renders in that phase. Only ever
 * mounted on the /preview/:guid route - never on a published page.
 */
export function PhasePreviewSwitcher({ tweaks, setTweak }: PhasePreviewSwitcherProps) {
  return (
    <TweaksPanel title="Fase-forhåndsvisning">
      <TweakSection label="Fase">
        <TweakRadio
          label="Kilde"
          value={tweaks.phaseMode}
          options={[
            { value: 'auto', label: 'Automatisk' },
            { value: 'manual', label: 'Manuel' },
          ]}
          onChange={(v) => setTweak('phaseMode', v)}
        />
        {tweaks.phaseMode === 'manual' && (
          <TweakSelect
            label="Vis som fase"
            value={tweaks.phaseManual}
            options={PHASE_SEQUENCE.map((p) => ({ value: p, label: PHASE_LABELS[p] }))}
            onChange={(v) => setTweak('phaseManual', v)}
          />
        )}
      </TweakSection>
    </TweaksPanel>
  );
}
